/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

const ContentTypes = {
  insights: "articles",
  stories: "interviews",
  "money-order": "newsletter/money-order",
  "bulls-eye": "newsletter/bulls-eye"
};

export default ContentTypes;
